import {
  LayoutDashboard,
  CalendarDays,
  CircleUserRound,
  FileUp,
  Printer,
  Trophy,
} from "lucide-react";
import { useState } from "react";
import CommandCenter from "./command-center";
import YearOver from "./year-over";
import AgentProductionTab from "./agent-production";
import RankingsSection from "./team-ranking";

function ReportHero() {
  const [activeTab, setActiveTab] = useState("command");

  const tabs = [
    { id: "command", label: "Command Center", icon: LayoutDashboard },
    { id: "yoy", label: "Year Over Year", icon: CalendarDays },
    {
      id: "agent-production",
      label: "Agent Production",
      icon: CircleUserRound,
    },
    { id: "rankings", label: "Team Rankings", icon: Trophy },
  ];

  return (
    <main className="">
      {/* ===== Header Section ===== */}
      <header className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left px-10 py-7 lg:py-5 border-b border-black/10 bg-white">
        {/* Title */}
        <div className="page-title">
          <h2 className="text-4xl font-bold bg-[#1E293B] bg-clip-text text-transparent">
            Reports & Analytics
          </h2>
        </div>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center lg:justify-end gap-3 mt-4 lg:mt-0">
          <button className="relative inline-flex items-center gap-2 px-5 sm:px-6 py-3 font-semibold text-gray-800 text-sm rounded-lg bg-gradient-to-r from-white/90 to-gray-200 shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300 overflow-hidden group" onClick={() => window.print()}>
            <span className="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 ease-out"></span>
            <Printer className="w-4 h-4" />
            <span className="relative">Print Report</span>
          </button>

          
        </div>
      </header>

      {/* ===== Tabs Section ===== */}
      <div className="w-[96%] mx-auto mt-8">
        <div className="flex gap-2 mb-8 bg-white shadow p-2 rounded-2xl overflow-x-auto scrollbar-hide panelScroll">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center justify-center gap-2 whitespace-nowrap px-4 sm:px-6 sm:w-[24%] py-3 rounded-lg font-semibold flex-shrink-0 transition-all ${
                activeTab === tab.id
                  ? "bg-[#1E293B] text-white"
                  : "bg-transparent text-gray-500 hover:bg-gray-100"
              }`}
            >
              {tab.icon && <tab.icon className="w-4 h-4" />}
              {tab.label}
            </button>
          ))}
        </div>

        {/* ===== Tab Content ===== */}
        {activeTab === "command" && <CommandCenter />}
        {activeTab === "yoy" && <YearOver />}
        {activeTab === "agent-production" && <AgentProductionTab />}
        {activeTab === "rankings" && <RankingsSection />}
      </div>
    </main>
  );
}

export default ReportHero;
